import { Utils } from '../../Core';
import { getCmsContentApi as API } from '../../Apis';
import { CmsContentTypes } from '../../Types';
import { mocksService } from './GetCmsContent.mocks';
import dataFields from '../../Types/CmsContent.json';

const invokeApiFunction = async (
  params: CmsContentTypes.CmsContentRequestType,
) => API.call.get(params);

export const { machine, Docs } = Utils.genericMachine({
  invokeApiFunction,
  definitionsAPI: API.definitions,
  mocksService,
  dataFields,
});
